import { withNavigationWatcher } from './contexts/navigation';
import {
  TasksPage,
  TestPage,
  WorkTimePage,
  EasyPayMessage,
  ShedulerPage,
  lazyComponents,
} from './pages/indexPages';

import { FC, LazyExoticComponent } from 'react';

interface RouteItem {
  path: string;
  component: FC<any> | keyof typeof lazyComponents | LazyExoticComponent<FC<any>>;
}
export const routesProtected: ReadonlyArray<RouteItem> = [
  { path: '/adminka', component: 'AdminkaPage' },
  { path: '/adminka/reports', component: 'AdminkaReportsPage' },
  { path: '/import-cars', component: 'ImportCarsPage' },
];

export const routes: ReadonlyArray<RouteItem> = [
  { path: '/tasks', component: TasksPage },
  { path: '/home', component: 'HomePage' },
  { path: '/crm', component: 'CRMPage' },
  { path: '/dashboard', component: 'DashboardPage' },
  { path: '/news', component: 'NewsPage' },
  { path: '/orders', component: 'OrdersPage' },
  { path: '/acts', component: 'ActsPage' },
  { path: '/lab_reports', component: 'LabReportsPage' },
  { path: '/lab_report/:id', component: 'LabReportPage' },
  { path: '/form_orders', component: 'FormOrdersPage' },
  { path: '/form_order/:id', component: 'FormOrderPage' },
  { path: '/price_orders', component: 'PriceOrdersPage' },
  { path: '/order/:id', component: 'OrderPage' },
  { path: '/orderCollections/', component: 'OrderCollections' },
  { path: '/orderCollections/:id', component: 'OrderCollectionsDoc' },
  { path: '/ordersforpay/', component: 'OrdersForPay' },
  { path: '/orderforpay/:id', component: 'OrderForPay' },
  { path: '/price_order/:id', component: 'PriceOrderPage' },
  { path: '/test/', component: TestPage },
  { path: '/ep', component: 'EPPage' },
  { path: '/ep/:id', component: 'EPOtkV2' },
  { path: '/ep-taho/:id', component: 'EPTachograph' },
  { path: '/ep-dio/:id', component: 'Diotrade' },
  { path: '/ep-co2/:id', component: 'EpCO2Form' },
  { path: '/ep-ekmt/:id', component: 'EKMT' },
  { path: '/manuals-moc', component: 'ManualMOC' },
  { path: '/manual/:id', component: 'ManualPage' },
  { path: '/policy', component: 'PolicyPage' },
  { path: '/policy/prices', component: 'InsurancePriceList' },
  { path: '/policy/:id', component: 'PolicyCard' },
  { path: '/policy-new', component: 'PolicyNew' },
  { path: '/oferta', component: 'ContractOffer' },
  { path: '/cash_flow_report', component: 'CashFlowReport' },
  { path: '/debitsbyact_report/:partner', component: 'DebitsByAct' },
  { path: '/debitsbyact_report', component: 'DebitsByAct' },
  { path: '/daylabreport', component: 'DayLabReport' },
  { path: '/pay_report', component: 'PayReport' },
  { path: '/openorder_report', component: 'OpenOrderReport' },
  { path: '/work_time/:id', component: WorkTimePage },
  { path: '/work_times', component: 'WorkTimeListPage' },
  { path: '/easypays', component: 'EasyPayList' },
  { path: '/easypaymessage/:id', component: EasyPayMessage },
  { path: '/pricelist', component: 'PriceList' },
  { path: '/sheduler', component: ShedulerPage },
  { path: '/termlist', component: 'TerminalListDocsPage' },
  { path: '/trusts', component: 'TrustsPage' },
];

export default routes.map((route) => ({
  ...route,
  element: withNavigationWatcher(route.component),
}));

export const routesWithAuth = routesProtected.map((route) => ({
  ...route,
  element: withNavigationWatcher(route.component),
}));
